import { Badge, Card, CardBody, CardHeader, DescriptionList } from '@bennows/boows-react';
import { useTranslation } from 'react-i18next';
import { useOutletContext } from 'react-router-dom';
import { PageHeader } from '../../components/PageHeader';
import { PasskeysCard } from './PasskeysCard';
import type { OperatorMe } from '../auth/useOperatorMe';

/** The signed-in operator: profile, permissions, authenticator app and passkeys (spec 140 §4.5, T460-1-4). */
export function AccountPage() {
  const { t } = useTranslation();
  const me = useOutletContext<OperatorMe>();
  return (
    <div className="ui-stack">
      <PageHeader title={t('account.title')} description={t('account.description')} />
      <Card as="section" aria-labelledby="account-profile">
        <CardHeader title={<span id="account-profile">{t('account.profile')}</span>} />
        <CardBody>
          <DescriptionList
            layout="inline"
            items={[
              { id: 'name', term: t('account.name'), description: me.display_name },
              { id: 'email', term: t('account.email'), description: me.email },
              { id: 'role', term: t('account.role'), description: t(`roles.${me.role}`) },
              {
                id: 'permissions',
                term: t('account.permissions'),
                description: (
                  <ul className="ui-console-list">
                    {me.permissions.map((permission) => (
                      <li key={permission}>{t(`permissions.${permission}`)}</li>
                    ))}
                  </ul>
                ),
              },
            ]}
          />
        </CardBody>
      </Card>
      <Card as="section" aria-labelledby="account-security">
        <CardHeader title={<span id="account-security">{t('account.security')}</span>} />
        <CardBody>
          <DescriptionList
            layout="inline"
            items={[
              {
                id: 'totp',
                term: t('account.secondFactor'),
                description: (
                  <span className="ui-console-stack">
                    <Badge tone="success">{t('account.secondFactorActive')}</Badge>
                    <span className="ui-console-muted">{t('account.secondFactorHint')}</span>
                  </span>
                ),
              },
            ]}
          />
        </CardBody>
      </Card>
      <PasskeysCard />
    </div>
  );
}
